<template>
  <div class="filing-info">
    <div class="filing-text">
      <span class="tipsTitle">版权所有：逻腾（杭州）科技有限公司</span>
      <a class="recordNumber" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备19042951号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilingInfo'
}
</script>

<style scoped>
.filing-info {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}

.filing-text {
  font-size: 12px;
  color: #999;
  opacity: 0.8;
  .tipsTitle{
    color: #ffffffd9;
    font-size: 12px;
    line-height: 16px;
    margin-right: 16px;
  }
  .recordNumber{
    color: #ffffffd9;
    font-size: 12px;
    line-height: 16px;
    margin-right: 16px;
    margin-top: 8px;
  }
  .recordNumber:hover{
    color: #fff;
  }
}
</style>
